import { Repository } from "./adapters/repository";
import { DateOps } from "./adapters/dateOps";

import * as createUnavailability from "./useCases/createUnavailability";
import * as retrieveUnavailabilityReasons from "./useCases/retrieveUnavailabilityReasons";
import * as retrieveUnavailabilities from "./useCases/retrieveUnavailabilities";
import * as editUnavailability from "./useCases/editUnavailability";
import * as removeUnavailability from "./useCases/removeUnavailability";

enum UseCases {
  createUnavailability = "createUnavailability",
  retrieveUnavailabilityReasons = "retrieveUnavailabilityReasons",
  retrieveUnavailabilities = "retrieveUnavailabilities",
  editUnavailability = "editUnavailability",
  removeUnavailability = "removeUnavailability",
}

interface Core {
  [UseCases.createUnavailability]: createUnavailability.Interactor;
  [UseCases.retrieveUnavailabilityReasons]: retrieveUnavailabilityReasons.Interactor;
  [UseCases.retrieveUnavailabilities]: retrieveUnavailabilities.Interactor;
  [UseCases.editUnavailability]: editUnavailability.Interactor;
  [UseCases.removeUnavailability]: removeUnavailability.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = { repository: Repository; dateOps: DateOps };

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.createUnavailability]: createUnavailability.createInteractor(
      dependencies.repository,
      dependencies.dateOps,
    ),
    [UseCases.retrieveUnavailabilityReasons]:
      retrieveUnavailabilityReasons.createInteractor(dependencies.repository),
    [UseCases.retrieveUnavailabilities]:
      retrieveUnavailabilities.createInteractor(dependencies.repository),
    [UseCases.editUnavailability]: editUnavailability.createInteractor(
      dependencies.repository,
      dependencies.dateOps,
    ),
    [UseCases.removeUnavailability]: removeUnavailability.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
